// Free Shipping Bar – Land direkt von Shopify Markets (kein externer API-Call)
(function () {
  var country_code = document.documentElement.getAttribute('data-country_code');
  var currency_code = document.querySelector(".mini-cart")?.getAttribute("currency_code");

  if (!country_code) return;

  var matchFound = freeshippingArr.some(function (item) {
    return item.country_code === country_code && item.currency_code === currency_code;
  });

  if (!matchFound) {
    document.body.classList.add("shippingbar_disabled");
  }
})();


// -------------------------------------------------------
// Bundle Varianten-Bild Fix
// Liest option1/option2 direkt aus – kein master select nötig
//
// Sprachfest (Paket P5): Die Varianten kommen aus /products/<handle>.js MIT
// Sprachpräfix (/en/products/…), also mit denselben übersetzten Optionswerten
// wie die Radios auf der Seite. Ohne Präfix lieferte Shopify die deutschen
// Werte, und auf /en/ traf nie eine Variante. Verglichen wird je Position
// (option1 ↔ options[0] …), nicht "irgendwo in der Liste".
// -------------------------------------------------------
(function () {

  const variantCache = {};

  function productJsUrl(handle) {
    const tv = window.themeVariables && window.themeVariables.routes;
    const root = tv && typeof tv.rootUrlWithoutSlash === 'string' ? tv.rootUrlWithoutSlash : '';
    return root + '/products/' + encodeURIComponent(handle) + '.js';
  }

  async function fetchVariants(handle) {
    if (variantCache[handle]) return variantCache[handle];
    try {
      const res = await fetch(productJsUrl(handle));
      const data = await res.json();
      variantCache[handle] = data.variants;
      return data.variants;
    } catch (e) { return null; }
  }

  // Ausgewählter Wert je Optionsposition (Index 0 = option1); null = nichts gewählt
  function getSelectedOptions(el) {
    const opts = [];
    [1, 2, 3].forEach(function(i) {
      const radio = el.querySelector('input[name="option' + i + '"]:checked');
      if (radio) { opts.push(radio.value); return; }
      const select = el.querySelector('select[name="option' + i + '"]');
      opts.push(select && select.value ? select.value : null);
    });
    return opts;
  }

  function setMainImage(variant) {
    if (!variant || !variant.featured_image) return;
    const fi = variant.featured_image;
    const baseSrc = fi.src.split('?')[0];
    const buildSrc = function(w) { return baseSrc.replace(/(\.[^.]+)$/, '_' + w + 'x$1'); };
    const mainImg = document.querySelector('.product__media-item.is-selected img');
    if (mainImg) {
      mainImg.src = buildSrc(1800);
      mainImg.srcset = [400,600,800,1000,1200,1400,1800]
        .map(function(w) { return buildSrc(w) + ' ' + w + 'w'; }).join(', ');
      if (fi.alt) mainImg.alt = fi.alt;
    }
  }

  function attachListeners(el) {
    const handle = el.getAttribute('handle');
    if (!handle) return;

    let timer = null;
    const onChange = function() {
      clearTimeout(timer);
      timer = setTimeout(async function() {
        const variants = await fetchVariants(handle);
        if (!variants) return;
        const selected = getSelectedOptions(el);
        const matched = variants.find(function(v) {
          return selected.every(function(opt, i) { return opt === null || v.options[i] === opt; });
        });
        setMainImage(matched);
      }, 150);
    };

    // Auf Radio-Inputs und Selects hören
    el.querySelectorAll('input[type="radio"]').forEach(function(r) {
      r.addEventListener('change', onChange);
    });
    el.querySelectorAll('select.visually-hidden').forEach(function(s) {
      s.addEventListener('change', onChange);
    });
    // Combo-Box Buttons
    el.querySelectorAll('.combo-box__option-item').forEach(function(btn) {
      btn.addEventListener('click', function() { setTimeout(onChange, 50); });
    });
  }

  function init() {
    document.querySelectorAll('product-variants[data-template-suffix="bundle"]').forEach(function(el) {
      if (!el.dataset.bundleFix) {
        el.dataset.bundleFix = '1';
        attachListeners(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // MutationObserver wird unten zentral registriert
  window.__bundleVariantFix_attachListeners = attachListeners;

})();

// -------------------------------------------------------
// Combo-Box Suchfeld
// Filtert Optionen live beim Tippen
// -------------------------------------------------------
(function () {
  function initComboBoxSearch(comboBox) {
    const input = comboBox.querySelector('.combo-box__search-input');
    if (!input) return;

    input.addEventListener('input', function () {
      const query = this.value.toLowerCase().trim();
      comboBox.querySelectorAll('.combo-box__option-item').forEach(function (item) {
        const match = item.textContent.toLowerCase().includes(query);
        item.hidden = !match;
      });
    });

    // Suchfeld leeren wenn Combo-Box geschlossen wird
    comboBox.addEventListener('close', function () {
      input.value = '';
      comboBox.querySelectorAll('.combo-box__option-item').forEach(function (item) {
        item.hidden = false;
      });
    });

    // Beim Öffnen Fokus auf Suchfeld
    const observer = new MutationObserver(function () {
      if (comboBox.hasAttribute('open')) {
        setTimeout(() => input.focus(), 200);
      } else {
        input.value = '';
        comboBox.querySelectorAll('.combo-box__option-item').forEach(function (item) {
          item.hidden = false;
        });
      }
    });
    observer.observe(comboBox, { attributes: true, attributeFilter: ['open'] });
  }

  function init() {
    document.querySelectorAll('combo-box').forEach(function (cb) {
      if (!cb.dataset.searchInit) {
        cb.dataset.searchInit = '1';
        initComboBoxSearch(cb);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // MutationObserver wird unten zentral registriert
  window.__comboBoxSearch_init = initComboBoxSearch;
})();


// -------------------------------------------------------
// Ketten Image Swatches (ewph-v2)
// Liest ketten_bilder JSON aus dem Metafeld und
// aktualisiert Bilder wenn Farbe (Gold/Silber) wechselt
//
// Sprachfest (Paket P5): Das Metafeld führt die Werte nur auf Deutsch und
// Englisch. Findet ein Bild über den angezeigten (übersetzten) Wert nichts,
// wird derselbe Wert über seine POSITION in der Hauptsprache nachgeschlagen:
// /products/<handle>.js OHNE Sprachpräfix liefert die Optionswerte der
// Hauptsprache, options[Position - 1].values[Index]. DE/EN treffen schon
// beim ersten Versuch — dort läuft kein zusätzlicher Abruf.
// -------------------------------------------------------
(function () {

  const primaerCache = {};

  function fetchPrimaerOptionen(handle) {
    if (!primaerCache[handle]) {
      primaerCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (res) { return res.json(); })
        .then(function (data) { return data.options || null; })
        .catch(function () { return null; });
    }
    return primaerCache[handle];
  }

  function parseKettenBilder(swatchList) {
    const raw = swatchList.getAttribute('data-ketten-bilder');
    if (!raw) return null;
    try {
      // Shopify gibt Metafeld-Hash manchmal als Ruby-Syntax aus (=> statt :)
      return JSON.parse(raw.replace(/=>/g, ':'));
    } catch (e) {
      return null;
    }
  }

  // Suche case-insensitive
  function findeSchluessel(obj, name) {
    if (!obj || name == null) return null;
    const n = String(name).toLowerCase();
    return Object.keys(obj).reduce(function (found, key) {
      return found || (key.toLowerCase() === n ? obj[key] : null);
    }, null);
  }

  function setzeBild(img, bildUrl) {
    if (img.getAttribute('src') === bildUrl) return;
    img.classList.add('is-loading');
    const newImg = new Image();
    newImg.onload = function () {
      img.src = bildUrl;
      img.classList.remove('is-loading');
    };
    newImg.src = bildUrl;
  }

  // farbe = { value, position, index } der gewählten Farbe; primaer = Optionen der Hauptsprache (oder null)
  function updateKettenImages(swatchList, kettenBilder, farbe, primaer) {
    let farbenBilder = findeSchluessel(kettenBilder, farbe.value);
    if (!farbenBilder && primaer && primaer[farbe.position - 1]) {
      farbenBilder = findeSchluessel(kettenBilder, primaer[farbe.position - 1].values[farbe.index]);
    }
    const kettePos = Number(swatchList.getAttribute('data-option-position'));
    let offen = 0;
    swatchList.querySelectorAll('img[data-kette]').forEach(function (img) {
      let bildUrl = findeSchluessel(farbenBilder, img.getAttribute('data-kette'));
      if (!bildUrl && primaer && primaer[kettePos - 1]) {
        bildUrl = findeSchluessel(farbenBilder, primaer[kettePos - 1].values[Number(img.getAttribute('data-kette-index'))]);
      }
      if (bildUrl) setzeBild(img, bildUrl); else offen++;
    });
    return offen;
  }

  function getSelectedFarbe(productVariants) {
    // Erste gewählte Option, die NICHT im image-swatch-list steckt — samt Position und Index
    const radios = productVariants.querySelectorAll('input[type="radio"]:checked');
    for (const r of radios) {
      if (r.closest('.image-swatch-list')) continue;
      const m = /^option(\d+)$/.exec(r.name || '');
      const gruppe = Array.prototype.filter.call(
        productVariants.querySelectorAll('input[type="radio"]'),
        function (x) { return x.name === r.name && !x.closest('.image-swatch-list'); });
      return { value: r.value, position: m ? Number(m[1]) : 0, index: gruppe.indexOf(r) };
    }
    return null;
  }

  function initKettenSwatches(swatchList) {
    const productVariants = swatchList.closest('product-variants');
    if (!productVariants) return;
    const kettenBilder = parseKettenBilder(swatchList);
    if (!kettenBilder) return;
    const handle = productVariants.getAttribute('handle');

    // Initial: Farbe ermitteln und Bilder setzen
    function refreshImages() {
      const farbe = getSelectedFarbe(productVariants);
      if (!farbe) return;
      if (updateKettenImages(swatchList, kettenBilder, farbe, null) && handle) {
        fetchPrimaerOptionen(handle).then(function (primaer) {
          if (primaer) updateKettenImages(swatchList, kettenBilder, getSelectedFarbe(productVariants) || farbe, primaer);
        });
      }
    }

    refreshImages();

    // Auf Farb-Änderung lauschen (alle Radios die NICHT im image-swatch-list sind)
    productVariants.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      if (!radio.closest('.image-swatch-list')) {
        radio.addEventListener('change', refreshImages);
      }
    });
  }

  function init() {
    const lists = document.querySelectorAll('.image-swatch-list');
    lists.forEach(function (list) {
      if (!list.dataset.ketteInit) {
        list.dataset.ketteInit = '1';
        initKettenSwatches(list);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // MutationObserver wird unten zentral registriert
  window.__kettenSwatches_init = initKettenSwatches;

})();


// -------------------------------------------------------
// Bundle: Farb-Selektor visuell vor Ketten-Selektor
// WICHTIG: CSS order statt DOM-Reorder, damit
// _getSelectedOptionValues() korrekt option1/option2 liest
// und ausverkaufte Varianten richtig erkannt werden.
// -------------------------------------------------------
(function () {

  function reorderSelectorsCSS(productVariants) {
    productVariants.style.display = 'flex';
    productVariants.style.flexDirection = 'column';

    var colorSelector = productVariants.querySelector('.product-form__option-selector[data-selector-type="color"]');
    if (colorSelector) {
      colorSelector.style.order = '-1';
    }
  }

  function init() {
    document.querySelectorAll('product-variants[data-template-suffix="bundle"]').forEach(function (el) {
      if (!el.dataset.reorderDone) {
        el.dataset.reorderDone = '1';
        reorderSelectorsCSS(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // MutationObserver wird unten zentral registriert
  window.__bundleReorder_init = reorderSelectorsCSS;

})();


// -------------------------------------------------------
// Zentraler MutationObserver (statt 4 separate)
// Ein einziger Observer mit Debounce, statt 4 die bei
// jeder DOM-Änderung einzeln querySelectorAll feuern.
// -------------------------------------------------------
(function () {
  var debounceTimer = null;

  function processNewElements() {
    // Bundle Variant Fix
    if (window.__bundleVariantFix_attachListeners) {
      document.querySelectorAll('product-variants[data-template-suffix="bundle"]:not([data-bundle-fix])').forEach(function(el) {
        el.dataset.bundleFix = '1';
        window.__bundleVariantFix_attachListeners(el);
      });
    }

    // Combo-Box Search
    if (window.__comboBoxSearch_init) {
      document.querySelectorAll('combo-box:not([data-search-init])').forEach(function (cb) {
        cb.dataset.searchInit = '1';
        window.__comboBoxSearch_init(cb);
      });
    }

    // Ketten Image Swatches
    if (window.__kettenSwatches_init) {
      document.querySelectorAll('.image-swatch-list:not([data-kette-init])').forEach(function (list) {
        list.dataset.ketteInit = '1';
        window.__kettenSwatches_init(list);
      });
    }

    // Bundle Reorder
    if (window.__bundleReorder_init) {
      document.querySelectorAll('product-variants[data-template-suffix="bundle"]:not([data-reorder-done])').forEach(function (el) {
        el.dataset.reorderDone = '1';
        window.__bundleReorder_init(el);
      });
    }
  }

  new MutationObserver(function () {
    if (debounceTimer) return;
    debounceTimer = requestAnimationFrame(function () {
      debounceTimer = null;
      processNewElements();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();


// Klaviyos nativen BIS-Button verstecken – wir nutzen unseren eigenen
(function() {
  var style = document.createElement('style');
  style.textContent = '.klaviyo-bis-button-container { display: none !important; } .kl-private-reset-css-Xuajs1 { display: none !important; } .klaviyo-bis-custom-button { background-position: 100% 100% !important; }';
  document.head.appendChild(style);
})();

// -------------------------------------------------------
// Klaviyo Back in Stock – Eigenes Formular via direkter API
//
// Wir umgehen Klaviyos DOM-Scanning komplett und posten
// die E-Mail-Adresse direkt an Klaviyos Subscribe-Endpoint.
// Company ID: WzUNw5
// -------------------------------------------------------
(function () {

  var KLAVIYO_COMPANY_ID = 'WzUNw5';
  var SHOP_DOMAIN = 'dorigine-com.myshopify.com';

  // Texte aus den Sprachdateien (dorigine.back_in_stock.*) über window.themeVariables.strings
  // (snippets/js-variables.liquid, dort bereits HTML-dekodiert).
  var BIS_S = (window.themeVariables && window.themeVariables.strings) || {};
  var BIS_T = {
    title: BIS_S.backInStockTitle || '',
    text: BIS_S.backInStockText || '',
    email: BIS_S.backInStockEmail || '',
    button: BIS_S.backInStockButton || '',
    invalid: BIS_S.backInStockInvalid || '',
    success: BIS_S.backInStockSuccess || '',
    saved: BIS_S.backInStockSaved || '',
    error: BIS_S.backInStockError || ''
  };

  // Texte werden unten per innerHTML eingesetzt -> für HTML maskieren (Apostroph/& in Übersetzungen)
  function bisEsc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // Modal HTML einfügen
  function createModal() {
    if (document.getElementById('bis-modal')) return;
    var modal = document.createElement('div');
    modal.id = 'bis-modal';
    modal.style.cssText = 'display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:99999;align-items:center;justify-content:center;';
    modal.innerHTML = '<div style="background:#fff;padding:32px;max-width:400px;width:90%;border-radius:8px;position:relative;">' +
      '<button id="bis-modal-close" type="button" style="position:absolute;top:12px;right:16px;background:none;border:none;font-size:20px;cursor:pointer;">✕</button>' +
      '<h3 style="margin:0 0 8px;font-size:18px;">' + bisEsc(BIS_T.title) + '</h3>' +
      '<p style="margin:0 0 16px;font-size:14px;color:#666;">' + bisEsc(BIS_T.text) + '</p>' +
      '<input id="bis-email-input" type="email" placeholder="' + bisEsc(BIS_T.email) + '" style="width:100%;padding:10px;border:1px solid #ccc;border-radius:4px;font-size:14px;box-sizing:border-box;margin-bottom:12px;">' +
      '<button id="bis-submit-btn" type="button" style="width:100%;padding:12px;background:#000;color:#fff;border:none;border-radius:4px;font-size:14px;cursor:pointer;">' + bisEsc(BIS_T.button) + '</button>' +
      '<p id="bis-message" style="margin:8px 0 0;font-size:13px;text-align:center;"></p>' +
    '</div>';
    document.body.appendChild(modal);

    document.getElementById('bis-modal-close').addEventListener('click', closeModal);
    modal.addEventListener('click', function(e) { if (e.target === modal) closeModal(); });
    document.getElementById('bis-submit-btn').addEventListener('click', submitBIS);
  }

  function openModal(variantId, productId) {
    createModal();
    var modal = document.getElementById('bis-modal');
    modal.dataset.variantId = variantId;
    modal.dataset.productId = productId;
    modal.style.display = 'flex';
    document.getElementById('bis-email-input').value = '';
    document.getElementById('bis-message').textContent = '';
    setTimeout(function() { document.getElementById('bis-email-input').focus(); }, 100);
  }

  function closeModal() {
    var modal = document.getElementById('bis-modal');
    if (modal) modal.style.display = 'none';
  }

  function submitBIS() {
    var modal = document.getElementById('bis-modal');
    var email = document.getElementById('bis-email-input').value.trim();
    var variantId = modal.dataset.variantId;
    var msg = document.getElementById('bis-message');
    var btn = document.getElementById('bis-submit-btn');

    if (!email || !email.includes('@')) {
      msg.style.color = 'red';
      msg.textContent = BIS_T.invalid;
      return;
    }

    btn.disabled = true;
    btn.textContent = '...';

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-06-15'
      },
      body: JSON.stringify(payload)
    })
    .then(function(res) {
      // 202 = Erfolg, kein Body
      if (res.status === 202) {
        msg.style.color = 'green';
        msg.textContent = BIS_T.success;
        btn.textContent = BIS_T.saved;
        setTimeout(closeModal, 2500);
      } else {
        throw new Error('Status ' + res.status);
      }
    })
    .catch(function() {
      msg.style.color = 'red';
      msg.textContent = BIS_T.error;
      btn.disabled = false;
      btn.textContent = BIS_T.button;
    });
  }

  function updateBisWrapper(formId, variant) {
    var wrapper = document.querySelector('.klaviyo-bis-wrapper[data-form-id="' + formId + '"]');
    if (!wrapper) return;

    if (variant && !variant.available) {
      var trigger = wrapper.querySelector('[klaviyo-bis-trigger]');
      if (trigger) trigger.setAttribute('data-variant-id', variant.id);
      wrapper.style.removeProperty('display');
    } else {
      wrapper.style.display = 'none';
    }
  }

  function initBisButtons() {
    document.querySelectorAll('.klaviyo-bis-custom-button:not([data-bis-init])').forEach(function (btn) {
      btn.dataset.bisInit = '1';
      btn.addEventListener('click', function () {
        var wrapper = btn.closest('.klaviyo-bis-wrapper');
        if (!wrapper) return;
        var trigger = wrapper.querySelector('[klaviyo-bis-trigger]');
        var variantId = trigger ? trigger.getAttribute('data-variant-id') : null;
        var productId = trigger ? trigger.getAttribute('data-product-id') : null;
        if (variantId && productId) openModal(variantId, productId);
      });
    });
  }

  function initKlaviyoBIS() {
    document.querySelectorAll('form[is="product-form"]').forEach(function (form) {
      if (form.dataset.klaviyoBisInit) return;
      form.dataset.klaviyoBisInit = '1';
      form.addEventListener('variant:changed', function (e) {
        updateBisWrapper(form.getAttribute('id'), e.detail && e.detail.variant);
      });
    });
    initBisButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKlaviyoBIS);
  } else {
    initKlaviyoBIS();
  }

  new MutationObserver(function () {
    document.querySelectorAll('form[is="product-form"]:not([data-klaviyo-bis-init])').forEach(function (form) {
      form.dataset.klaviyoBisInit = '1';
      form.addEventListener('variant:changed', function (e) {
        updateBisWrapper(form.getAttribute('id'), e.detail && e.detail.variant);
      });
    });
    initBisButtons();
  }).observe(document.body, { childList: true, subtree: true });

})();

(function () {
  const properties = ['--dorigine-card-image-height', '--dorigine-card-title-height', '--dorigine-card-price-height', '--dorigine-card-after-price-space'];
  const observed = new WeakMap();
  let frame = 0;

  function schedule() {
    if (!frame) frame = requestAnimationFrame(align);
  }

  const resizeObserver = new ResizeObserver(entries => {
    for (const entry of entries) {
      const width = entry.contentRect.width;
      if (observed.get(entry.target) !== width) {
        observed.set(entry.target, width);
        schedule();
      }
    }
  });

  const titleSources = new WeakMap();

  function genderOf(text) {
    const women = /\b(damen|women|ladies)\b/i.test(text);
    const men = /\b(herren|men)\b/i.test(text);
    return women === men ? null : women ? 'women' : 'men';
  }

  function headingFor(list) {
    if (!document.body.classList.contains('dorigine-homepage')) return '';
    const section = list.closest('.shopify-section');
    if (section?.matches('.shopify-section--featured-collections')) {
      const productList = list.closest('product-list');
      const tab = [...section.querySelectorAll('.tabs-nav__item')].find(item => item.getAttribute('aria-controls') === productList?.id);
      const heading = section.querySelector('.section__header h3')?.textContent || '';
      return heading + ' ' + (tab?.textContent || '');
    }
    return '';
  }

  function shortenTitle(title, gender) {
    if (!title) return;
    const current = title.textContent;
    let source = titleSources.get(title);
    if (!source || current !== source.rendered) source = {full: current};
    const visible = gender ? source.full.replace(/\s*\|\s*(Damen|Herren|Women|Men|Ladies)\b(?:\s*[-–]\s*|\s*$)/gi, (match, label, offset, full) => {
      if (genderOf(label) !== gender) return match;
      return full.slice(offset + match.length).trim() ? ' | ' : '';
    }) : source.full;
    if (title.textContent !== visible) title.textContent = visible;
    if (title.getAttribute('aria-label') !== source.full) title.setAttribute('aria-label', source.full);
    if (title.getAttribute('title') !== source.full) title.setAttribute('title', source.full);
    source.rendered = visible;
    titleSources.set(title, source);
  }

  function align() {
    frame = 0;
    document.querySelectorAll('.product-list__inner').forEach(list => {
      if (!observed.has(list)) {
        observed.set(list, list.getBoundingClientRect().width);
        resizeObserver.observe(list);
      }
      const cards = [...list.children].map(cell => cell.matches('.product-tag-wrap') ? cell.querySelector(':scope > .product-item') : cell).filter(card => card?.matches('.product-item:not(.ed-spotlight-full-width)'));
      cards.forEach(card => properties.forEach(property => card.style.removeProperty(property)));
      const rows = new Map();
      const gender = genderOf(headingFor(list));
      cards.forEach(card => {
        if (!card.getBoundingClientRect().width) return;
        const info = card.querySelector(':scope > .product-item__info > .product-item-meta');
        if (!info) return;
        shortenTitle(info.querySelector(':scope > .product-item-meta__title'), gender);
        const cell = card.parentElement === list ? card : card.parentElement;
        const key = Math.round(card.offsetTop + (card.offsetParent === cell ? cell.offsetTop : 0));
        if (!rows.has(key)) rows.set(key, []);
        rows.get(key).push({
          card,
          image: card.querySelector(':scope > .product-item__image-wrapper'),
          title: info.querySelector(':scope > .product-item-meta__title'),
          price: info.querySelector(':scope > .product-item-meta__price-list-container'),
          swatches: info.querySelector(':scope > .product-item-meta__swatch-list')
        });
      });
      rows.forEach(row => {
        ['image', 'title', 'price'].forEach(part => {
          const height = Math.max(...row.map(item => item[part]?.getBoundingClientRect().height || 0));
          row.forEach(item => item.card.style.setProperty('--dorigine-card-' + part + '-height', height + 'px'));
        });
        const withSwatches = row.filter(item => item.price?.getBoundingClientRect().height && item.swatches);
        const gaps = withSwatches.map(item => item.swatches.getBoundingClientRect().top - item.price.getBoundingClientRect().bottom);
        const largestGap = Math.max(0, ...gaps);
        withSwatches.forEach((item, index) => {
          item.card.style.setProperty('--dorigine-card-after-price-space', Math.max(0, largestGap - gaps[index]) + 'px');
        });
      });
    });
  }

  new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true, characterData: true});
  window.addEventListener('resize', schedule, {passive: true});
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('load', event => {
    if (event.target.matches?.('.product-item img')) schedule();
  }, true);
  document.fonts?.ready.then(schedule);
  document.fonts?.addEventListener('loadingdone', schedule);
  schedule();
})();
